import React from 'react';
import { Divider } from 'semantic-ui-react';
import './index.scss';

const transUnionScoreBand = [
  {
    range: '613+',
    color: '#006400', // Dark Green
    description: 'AA',
  },
  {
    range: '590 - 612',
    color: '#6B8E23', // Olive Green
    description: 'BB',
  },
  {
    range: '574 - 589',
    color: '#40E0D0', // Turquoise
    description: 'CC',
  },
  {
    range: '562 - 573',
    color: '#1E90FF', // Dodger Blue
    description: 'DD',
  },
  {
    range: '547 - 561',
    color: '#FFFF99', // Light Yellow
    description: 'EE',
  },
  {
    range: '521 - 546',
    color: '#FFD700', // Golden Yellow
    description: 'FF',
  },
  {
    range: '516 - 520',
    color: '#FFA07A', // Light Salmon
    description: 'GG',
  },
  {
    range: '482 - 515',
    color: '#FF8C00', // Dark Orange
    description: 'HH',
  },
  {
    range: '468 - 481',
    color: '#F4A460', // Sandy Brown
    description: 'II',
  },
  {
    range: '1 - 467',
    color: '#8B0000', // Dark Red
    description: 'JJ',
  },
];

export const getColorForScore = score => {
  const band = transUnionScoreBand.find(({ range }) => {
    if (range.includes('+')) {
      const min = parseInt(range, 10);
      return score >= min;
    }
    const [min, max] = range
      .split('-')
      .map(n => parseInt(n.trim(), 10));
    return score >= min && score <= max;
  });

  return band ? band.color : null;
};

const TransUnionScoreBandPopup = () => {
  return (
    <div className="loan-request-info-popup__body__requester-info__popup">
      <div className="loan-request-info-popup__body__requester-info__popup__title">
        TransUnion Score Band
      </div>
      <Divider />
      <div className="loan-request-info-popup__body__requester-info__popup__body">
        {transUnionScoreBand.map(({ range, color, description }) => {
          return (
            <div className="loan-request-info-popup__body__requester-info__popup__body__item">
              <div
                className="loan-request-info-popup__body__requester-info__popup__body__item__color"
                style={{
                  backgroundColor: `${color}`,
                }}
              />
              <div className="loan-request-info-popup__body__requester-info__popup__body__item__data">
                <span className="loan-request-info-popup__body__requester-info__popup__body__item__score">
                  {range}
                </span>
                <span className="loan-request-info-popup__body__requester-info__item__phone">
                  {description}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TransUnionScoreBandPopup;
